export class ArrayUtils {

    public static cloneMatrix(input:any[][]):any[][] {
        const result = [];
        for (let column of input){
            result.push([...column]);
        }

        return result;
    }

    public static isAllTrue(array:boolean[]):boolean {
        for (let value of array) {
            if (!value) {
                return false;
            }
        }
        return true;
    }
}